// Frontend feature registry — mirror of backend/config/featureRegistry.js.
//
// LEAF MODULE: imports only types. Keys are the wire contract with the backend; parity is
// enforced at build time by backend/scripts/verify-rbac-registry.js (a static file read),
// NOT a runtime cross-package import — keeping this a leaf module avoids the init-order
// white-screen class of bug. The frontend only ever CONSUMES permissions[featureKey]
// returned by GET /api/auth/me/permissions.

export type Capability = 'none' | 'view' | 'edit';

export type FeatureKey =
  | 'add-bundle'
  | 'reduce-bundle'
  | 'saved-drafts'
  | 'bundle-skus'
  | 'bundle-combination'
  | 'view-inventory'
  | 'sync-inventory'
  | 'cyclic-count'
  | 'carding'
  | 'image-generation'
  | 'activities'
  | 'settings'
  | 'manage-users'
  | 'access-control';

export interface FeatureDef {
  key: FeatureKey;
  label: string;
}

export const FEATURES: FeatureDef[] = [
  { key: 'add-bundle', label: 'Add Bundle' },
  { key: 'reduce-bundle', label: 'Reduce Bundle' },
  { key: 'saved-drafts', label: 'Saved Drafts' },
  { key: 'bundle-skus', label: 'Bundle SKUs' },
  { key: 'bundle-combination', label: 'Bundle Combination' },
  { key: 'view-inventory', label: 'View Inventory' },
  { key: 'sync-inventory', label: 'Sync Inventory' },
  { key: 'cyclic-count', label: 'Cyclic Count' },
  { key: 'carding', label: 'Carding' },
  { key: 'image-generation', label: 'Image Generation' },
  { key: 'activities', label: 'Activities' },
  { key: 'settings', label: 'Settings' },
  { key: 'manage-users', label: 'Manage Users' },
  { key: 'access-control', label: 'Access Control' },
];

export const FEATURE_KEYS: FeatureKey[] = FEATURES.map((f) => f.key);
